import { useState } from 'react';

export function useWithLoadingState<TArgs extends unknown[], TResp>(func: (...args: TArgs) => Promise<TResp>) {
  const [isLoading, setIsLoading] = useState(false);

  const wrappedFunction = async (...args: TArgs): Promise<TResp> => {
    setIsLoading(true);
    try {
      const result = await func(...args);
      return result;
    } finally {
      setIsLoading(false);
    }
  };

  return [wrappedFunction, isLoading] as const;
}
